
import { useDispatch, useSelector } from "react-redux";
import Errors from "../Errors";
import "./styles.scss";
import { clearError } from "store/reducers/errors";
import { RootState } from "store";
import ErrorModal from "components/library/modals/ErrorModal";


const ErrorWrapper = () => {
    const dispatch = useDispatch();
    const error = useSelector((state: RootState)=> state.error)
    const resetError = () => {
        dispatch(clearError());
    };

    if (error.status)
        return (
            <div className="error-popup-view">
                <ErrorModal onClose={resetError} title="Sorry Something went wrong">      
                    <Errors errorCode={error.status} />
                </ErrorModal>
            </div>
        );
    else return null;
};

export default ErrorWrapper;
